
(function () {
  'use strict';

  function getMenu()   { return document.querySelector('header-drawer details, menu-drawer details'); }
  function getSearch() { return document.querySelector('details-modal details'); }
  function getCart()   { return document.querySelector('cart-drawer'); }

  function closeMenu() {
    var d = getMenu();
    if (d && d.hasAttribute('open')) d.removeAttribute('open');
  }

  function closeSearch() {
    var d = getSearch();
    if (d && d.hasAttribute('open')) d.removeAttribute('open');
  }

  function closeCart() {
    var c = getCart();
    if (!c || !c.classList.contains('active')) return;
    if (typeof c.close === 'function') {
      c.close();
    } else {
      c.classList.remove('active');
    }
  }

  function init() {
    var menu = getMenu();
    var search = getSearch();
    var cart = getCart();

    if (menu) {
      menu.addEventListener('toggle', function () {
        if (menu.open) { closeSearch(); closeCart(); }
      });
    }

    if (search) {
      search.addEventListener('toggle', function () {
        if (search.open) { closeMenu(); closeCart(); }
      });
    }

    if (cart && typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        if (cart.classList.contains('active')) {
          closeMenu();
          closeSearch();
        }
      }).observe(cart, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
